module.exports = {"TXTMOB_Win_up_to_N0X":{"id":"TXTMOB_Win_up_to_N0X","defaultMessage":"Gagnez jusqu''à {0} !"}}